import React, { useState } from 'react';
import Spacer from '../../../components/presentational/Spacer';
import styled, { cx, StylesProps } from '../../../lib/styles';
import BlockWrapper from '../BlockWrapper';
import { CallToActionButton } from '../CallToActionButton';
import { ButtonPosition, DefaultBlockFields } from '../GroupBlock';

import columnBlockStyles from './ColumnBlock_styles';
import Typography from '../../../components/presentational/Typography';
import { Brand } from '../../../lib/theme';
import BlockTitle from '../BlockTitle';
import _ from 'lodash';

export interface ColumnBlockProps {
  type: 'acf_columns_block';
  brand: string;
  classes: string;
  background_colour: string;
  desktop_spacing: string;
  mobile_spacing: string;
  block: ColumnBlockFields;
}

export interface ColumnBlockFields extends DefaultBlockFields {
  total_columns: number;
  columns: Column[];
}

interface Column {
  column_content: string;
}

const ColumnBlock = ({
  type,
  classes,
  brand,
  background_colour,
  desktop_spacing,
  mobile_spacing,
  block: { title, subtitle, columns, cta_button },
  styles,
}: ColumnBlockProps & StylesProps<typeof columnBlockStyles>) => {
  // console.log('ColumnBlock', {total_columns, ...columns})
  const total_columns = columns.length;
  return (
    <BlockWrapper
      {...{
        type,
        classes,
        brand,
        background_colour,
        desktop_spacing,
        mobile_spacing,
      }}
    >
      <Spacer
        space={['m', 'l']}
        className={cx(`columns-container container mb-2`, styles.container)}
      >
        {(cta_button.label || cta_button.icon) &&
          (cta_button.button_position == ButtonPosition.Above ||
            cta_button.button_position == ButtonPosition.AboveAndBelow) && (
            <CallToActionButton
              {..._.merge(cta_button, { cta_classes: 'mb-2' })}
            />
          )}

        <BlockTitle {...{ title, subtitle, brand }} />

        {columns.length > 0 && (
          <div
            className={`columns-container d-flex flex-wrap justify-content-between ${styles.columnsContainer}`}
            style={{
              flexWrap: 'wrap',
              gap: '1rem',
            }}
          >
            {columns &&
              columns.map((column, index) => {
                // console.log('Column', {...column})
                return (
                  <div
                    key={index}
                    className={`d-flex flex-column column-item ${styles.columnItem}}`}
                    style={{
                      flexBasis: `calc(${100 / total_columns}% - 1rem)`,
                      maxWidth: `calc(${100 / total_columns}% - 1rem)`,
                    }}
                    dangerouslySetInnerHTML={{ __html: column.column_content }}
                  ></div>
                );
              })}
          </div>
        )}
        {(cta_button.label || cta_button.icon) &&
          (cta_button.button_position == ButtonPosition.Below ||
            cta_button.button_position == ButtonPosition.AboveAndBelow) && (
            <CallToActionButton
              {..._.merge(cta_button, { cta_classes: 'mt-4 mb-2' })}
            />
          )}
      </Spacer>
    </BlockWrapper>
  );
};

export default styled(columnBlockStyles)(ColumnBlock);
